import React from "react";

const Laundry: React.FC<{ data: any }> = ({
    data,
}) => {
    return (
        <div style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
        }}>
            <h4 style={{ textTransform: "capitalize", marginLeft: "1.5rem"}}>{data.site.toLowerCase()}</h4>
            <div style={{display: "flex"}}>
                <div style={{display: "flex", flexDirection: "column", flexGrow: 1, flexBasis: 1, textAlign: "center", paddingBottom: "1rem"}}>
                    <span
                        style={{ color: data.available_washers > 0 ? "#2bd22b" : "#e62f2f", fontSize: 36, marginBottom: "0.5rem" }}
                    >
                        {data.available_washers}
                    </span>
                    <div style={{fontWeight: 500}}>{` Washer${data.available_washers === 1 ? " " : "s "} free`}</div>
                </div>
                <div style={{display: "flex", flexDirection: "column", flexGrow: 1, flexBasis: 1, textAlign: "center", paddingBottom: "1rem"}}>
                    <span
                        style={{ color: data.available_dryers > 0 ? "#2bd22b" : "#e62f2f", fontSize: 36, marginBottom: "0.5rem" }}
                    >
                        {data.available_dryers}
                    </span>
                    <div style={{fontWeight: 500}}>{` Dryer${data.available_dryers === 1 ? " " : "s "} free`}</div>
                </div>
            </div>
        </div>
    );
};

export default Laundry;
